import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MODULES } from "../permissions/types/permission-types.js";
import { ProtectedFragment } from "../protectedFragment/protectedFragment.component.jsx";
import { useAuth } from "./contexts/AuthContextProvider.jsx";
import { ROUTES } from "./navigation.js";
import CustomerManagement from "../customerManagement/customerManagement.container.jsx";
import SystemNotice from "../systemNotice/systemNotice.container.jsx";

const Dashboard = lazy(() => import("../dashboard/dashboard.jsx"));
const EDO = lazy(() => import("../lcl/edoRequest.container.jsx"));
// const EDO = lazy(() => import("../edo/edo.container.jsx"));

const MDO = lazy(() => import("../mdo/mdo.container.jsx"));
const AccessManagement = lazy(
  () => import("../accessManagement/accessManagement.jsx")
);
const UserManagement = lazy(
  () => import("../userManagement/userManagement.container.jsx")
);
const UnAuthorizedAccess = lazy(() => import("../unauthorizedAccess/index.js"));
const Login = lazy(() => import("../loginContainer/loginContainer.jsx"));
const CreditBankSlipReUpload = lazy(
  () => import("../creditBankSlipReUpload/creditBankSlipReUpload.jsx")
);
const SettingsPage = lazy(() => import("../settings/settings.jsx"));
const InvoiceRequestsPage = lazy(() => import("../invoiceRequests/invoiceRequests.jsx"));
const ApprovalsPage = lazy(() => import("../approvals/approvals.jsx"));
const TerminalManagementPage = lazy(() => import("../terminalManagement/terminalManagement.container.jsx"));
const VesselNoticePage = lazy(() => import("../vesselNotice/vesselNotice.container.jsx"));
const GensoftTrackTracePage = lazy(() => import("../gensoftTrackTrace/gensoftTrackTrace.jsx"));
const SalesNominationPage = lazy(() => import("../salesNomination/salesNomination.jsx"));

const RouterRoutes = () => {
  const { isAuthenticated, isCustomer } = useAuth();

  return (
    <Routes>
      {isAuthenticated ? (
        <>
          <Route
            path={ROUTES.dashboard}
            element={
              <ProtectedFragment module={MODULES.DASHBOARD}>
                <Dashboard />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.edo}
            element={
              isCustomer ? (
                <EDO />
              ) : (
                <ProtectedFragment module={MODULES.EDO}>
                  <EDO />
                </ProtectedFragment>
              )
            }
          />
          {isCustomer && (
            <Route
              path={ROUTES.creditBankSlipReUpload}
              element={<CreditBankSlipReUpload />}
            />
          )}

          <Route
            path={ROUTES.userManagement}
            element={
              <ProtectedFragment module={MODULES.USER_MANAGEMENT}>
                <UserManagement />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.customerManagement}
            element={
              <ProtectedFragment module={MODULES.CUSTOMER_MANAGEMENT}>
                <CustomerManagement />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.mdo}
            element={
              <ProtectedFragment module={MODULES.MDO}>
                <MDO />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.accessManagement}
            element={
              <ProtectedFragment module={MODULES.ACCESS_MANAGEMENT}>
                <AccessManagement />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.noticeManagement}
            element={
              <ProtectedFragment module={MODULES.NOTICE_MANAGEMENT}>
                <SystemNotice />
              </ProtectedFragment>
            }
          />
          <Route path={ROUTES.settings} element={<SettingsPage />} />
          <Route path={ROUTES.invoiceRequests} element={<InvoiceRequestsPage />} />
          <Route
            path={ROUTES.approvals}
            element={
              <ProtectedFragment module={MODULES.APPROVALS}>
                <ApprovalsPage />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.terminalManagement}
            element={
              <ProtectedFragment module={MODULES.TERMINAL_MANAGEMENT}>
                <TerminalManagementPage />
              </ProtectedFragment>
            }
          />
          <Route
            path={ROUTES.vesselNotice}
            element={
              <ProtectedFragment module={MODULES.VESSEL_NOTICE}>
                <VesselNoticePage />
              </ProtectedFragment>
            }
          />
          <Route path={ROUTES.gensoftTrackTrace} element={<GensoftTrackTracePage />} />
          <Route
            path={ROUTES.salesNomination}
            element={
              <ProtectedFragment module={MODULES.SALES_NOMINATION}>
                <SalesNominationPage />
              </ProtectedFragment>
            }
          />
          <Route path={ROUTES.staffLogin} element={<Navigate to={ROUTES.dashboard} replace />} />
          <Route path={ROUTES.customerLogin} element={<Navigate to={ROUTES.dashboard} replace />} />
        </>
      ) : (
        <>
          <Route path={ROUTES.customerLogin} element={<Login type="login" />} />
          <Route path={ROUTES.staffLogin} element={<Login type="staff" />} />
          <Route
            path={ROUTES.forgotPassword}
            element={<Login type="forgotPassword" />}
          />
          <Route
            path={ROUTES.changePassword}
            element={<Login type="changePassword" />}
          />
        </>
      )}
      <Route
        path={ROUTES.unauthorizedAccess}
        element={<UnAuthorizedAccess />}
      />
      <Route path="/" element={<Navigate to={isAuthenticated ? ROUTES.dashboard : ROUTES.customerLogin} replace />} />
    </Routes>
  );
};

export default RouterRoutes;
